import { env } from '@config/env';

import { createConsoleReporter } from './consoleReporter';
import { createSentryReporter } from './sentryReporter';
import type { Reporter } from './types';

function pickReporter(): Reporter {
  if (env.VITE_SENTRY_DSN) {
    return createSentryReporter({
      dsn: env.VITE_SENTRY_DSN,
      environment: env.VITE_ENV,
    });
  }
  return createConsoleReporter();
}

/**
 * Global singleton — configured once at module load. Replace with a custom
 * reporter in tests via `__setReporter(fake)`.
 */
let reporter: Reporter = pickReporter();

export function getReporter(): Reporter {
  return reporter;
}

/** Test / debug override. */
export function __setReporter(custom: Reporter): void {
  reporter = custom;
}
